import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import TemplateBlocksForm from "components/form/TemplateBlocksForm";
import TemplateForm from "components/form/TemplateForm";

import { SaveContextProvider } from "context/save";

import { useTemplateId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Template modificato con successo",
        errorMsg: "Errore nella modifica del template",
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaTemplate() {
    const templateId = useTemplateId();

    return (
        <GridColumn className={"template-page"}>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Modifica template</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <TemplateForm templateId={templateId} />

                <TemplateBlocksForm templateId={templateId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaTemplate;
